import logo from '../logo.svg';
import '../App.css';
import { Routes, Route, Link } from "react-router-dom";
import Dashboard from "./Dashboard.js";
import { PlayersProvider } from "./PlayersProvider.js";
import ProtectedRoute from "./ProtectedRoute.js";

function App() {
  return (
    <div>
      <Routes>
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute> 
              <PlayersProvider>
                <Dashboard />
              </PlayersProvider>
            </ProtectedRoute>
          }
        />

        <Route
          path="/"
          element={
            <div className="App">
              <header className="App-header">
                <p>Page principale</p>
              </header>
            </div>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
